function headerWidth() {
    var header      = $('#_header'),
        workarea    = $('#_workarea').width();

    header.css({
        'max-width' :   workarea
    });
}